export default "__VITE_ASSET__ae2815de__"